import React, { useState, useEffect } from "react";
import { isUiEvent } from "../logic/WidgetUtils";

// Externals
import cn from "classnames";

// DevExtreme components
import { CheckBox } from 'devextreme-react/check-box';

// Component styles
import classes from "./Checkbox3StatesWidget.module.scss"; 

const EMPTY = null;

export function Checkbox3StatesWidget(props) {
  const { ui, data, config, writeBack } = props;
  const [localContent, setLocalContent] = useState(EMPTY);

  let widgetId = ui.id;
  let stringContent = localContent !== EMPTY ? localContent : data && data.content ? data.content.toLowerCase() : "null";
  let contentIsNull = (stringContent === "null");
  let content = contentIsNull ? undefined : (stringContent === "true");
  let label = config ? config.CheckboxLabel : "";
  let disabled = ui.readonly || (data && data.readonly);

  useEffect(() => {
    //console.log("Checkbox3StatesWidget data of " + ui.id + ": ", data);
    setLocalContent(EMPTY);
  }, [data]);

  const setContent = (args, wasNull) => {
    if (!isUiEvent(args)) return;
    let value = args.value
      ? (wasNull
        ? false
        : true)
      : null;
    let realValue = value !== null ? value.toString() : "null";
    setLocalContent(realValue);
    writeBack(realValue, true);
  };

  return (
    <CheckBox
      className={cn(classes.checkBox, disabled ? classes.disabled : "")}
      id={widgetId}
      value={content}
      text={label}
      onValueChanged={e => setContent(e, contentIsNull)}
      disabled={disabled}
      height={ui.controlHeight + "em"}
    />
  );
}